import React from 'react'
import type { StyleProperties } from '../styles/StyleProperties'
import { stylesToCSS } from '../styles/StyleProperties'
import { renderFiIcon } from './ReactIconPicker'

export interface BizFirstIconProps {
  /** FiIconName e.g. "FiFolder" — same value stored by ReactIconPicker */
  icon: string
  /** Full StyleBuilder output applied to the wrapper element */
  iconStyle?: StyleProperties
  /** SVG icon size in px. Default 20. */
  size?: number
  className?: string
  /** Additional inline style merged onto the wrapper after iconStyle */
  style?: React.CSSProperties
}

/**
 * BizFirstIcon — renders a Feather icon with a StyleBuilder-driven style applied.
 *
 * The wrapper <span> receives all iconStyle properties (background, padding, border,
 * shadow, transform, opacity…). The SVG color is driven by iconStyle.color, falling
 * back to currentColor so it inherits from the parent.
 */
export function BizFirstIcon({
  icon,
  iconStyle,
  size = 20,
  className,
  style,
}: BizFirstIconProps): React.ReactElement | null {
  if (!icon) return null

  const iconColor = iconStyle?.color ?? 'currentColor'

  const wrapperStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...(iconStyle ? stylesToCSS(iconStyle) : {}),
    ...style,
  }

  const rendered = renderFiIcon(icon, size, iconColor)
  if (!rendered) return null

  return (
    <span className={className} style={wrapperStyle}>
      {rendered}
    </span>
  )
}

export default BizFirstIcon
